// src/utils/addtocart.js 

import { isLoggedIn, getUser, getToken } from "./auth";

export const addToCart = async (product, quantity = 1, openLoginPopup) => {
  console.log("Adding to cart:", product);
  console.log("User logged in:", isLoggedIn());
  console.log("User info:", getUser());
  console.log("quantity", quantity);
  if (!isLoggedIn()) {
    openLoginPopup();
    return;
  }

  try {
    const token = getToken();

    const res = await fetch("https://host.aizoplug.com:3000/ecommerce/cart/add", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`   //IMPORTANT
      },
      body: JSON.stringify({
        product_id: product.id,
        quantity: quantity
      })
    });

    const data = await res.json();

    if (data.success) {
      // alert("Added to cart 🛒");
      //  Trigger navbar update
      window.dispatchEvent(new Event("cartUpdated"));
      return true;
    } else {
      return false;
    }

  } catch (err) {
    console.log(err);
    alert("Server error");
  }
};